export const CONFIG = {
    client_name : "buderus",
    client_display_name : "Buderus",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/buderus/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "12345",
    foerderung : true,
    show_funding_list: true,
    development_mode: false,
    gebaeude_typ_options: ["sfh", "mfh"],
}